import { PortalAccountDomain } from "../../../../../utils/enums"
import Utils from "../../../../../utils/utils"

export const CHECKOUT_COM_PUBLIC_KEY_TEST = 'pk_sbox_dl635mbmf2ee4u66d2fuyk5koei'
export const CHECKOUT_COM_PUBLIC_KEY_PROD = 'pk_5y5f2iimejazlzqp7lblajsshu6'
export const TMBM_CHECKOUT_COM_PUBLIC_KEY_PROD = 'pk_pxagxd6bjudj6qkl4szq6ivh7qk'
export const UK_CHECKOUT_COM_PUBLIC_KEY_PROD = 'pk_4xnkzus2njxequvbe4shavx4mq6';

export const getCheckoutComPulicKey = (portalAccountDomain?: PortalAccountDomain) => {
  if (Utils.isTestEnv()) return CHECKOUT_COM_PUBLIC_KEY_TEST

  switch (portalAccountDomain) {
    case PortalAccountDomain.TMBM:
    case PortalAccountDomain.TMCY:
    case PortalAccountDomain.TMLC:
    case PortalAccountDomain.TMSY:
      return TMBM_CHECKOUT_COM_PUBLIC_KEY_PROD
    case PortalAccountDomain.UK:
      return UK_CHECKOUT_COM_PUBLIC_KEY_PROD
    default:
      return CHECKOUT_COM_PUBLIC_KEY_PROD
  }
}

const getMerchantID = (portalAccountDomain?: PortalAccountDomain) => {
  switch (portalAccountDomain) {
    case PortalAccountDomain.TMNZ:
    case PortalAccountDomain.AU:
      return Utils.isTestEnv()
        ? 'merchant.apple-pay-test'
        : 'merchant.apple-pay-prod'
    default:
      return Utils.isTestEnv()
        ? 'merchant.apple-pay-test'
        : 'merchant.com.thinktrader.prod'
  }
}

// THPRT-6277 / TMJV-902: Checkout.com Frames -> Flow. The BE exposes the Flow
// sub-processors as their own records (org x currency x SubProcessor). These are
// the deposit processor names the FE routes to the hosted Flow drop-in.
export const CHECKOUT_APPLE_PAY_PROCESSOR = 'Checkout Apple Pay'
export const CHECKOUT_GOOGLE_PAY_PROCESSOR = 'Checkout Google Pay'
// Wallet Flow tiles render a single (full-width by default) pay button; the FE
// caps + centres it, unlike the card form which stays full-width.
export const CHECKOUT_WALLET_PROCESSORS = [CHECKOUT_APPLE_PAY_PROCESSOR, CHECKOUT_GOOGLE_PAY_PROCESSOR]
export const CHECKOUT_FLOW_PROCESSORS = ['Checkout CC', ...CHECKOUT_WALLET_PROCESSORS]

// THPRT-6277 (Apple Pay QR): the Flow Apple Pay tile is NOT gated on a client-side
// device check. `window.ApplePaySession` is Safari/Apple-device-only, so it hid the
// tile on Windows/Chrome even though Checkout.com Flow offers the iOS 18 cross-device
// QR flow ("Scan Code with iPhone") there. Flow's own `applepay.isAvailable()` is the
// correct capability signal and is evaluated at mount time in CheckoutFlow, which
// falls back to an inline message when Checkout reports Apple Pay unavailable. The
// legacy Frames wallet path below keeps its native device check (Frames' Apple Pay JS
// genuinely needs an on-device active card).

// Single source of truth mapping each Flow sub-processor record name to the
// canonical Checkout processor key used for its display title and icon, so the
// naming lives in one place rather than being duplicated per consumer.
export const CHECKOUT_FLOW_PROCESSOR_ALIASES: Record<string, string> = {
  'Checkout CC': 'CheckoutCom',
  'Checkout Apple Pay': 'Apple Pay',
  'Checkout Google Pay': 'Google Pay',
}

// The legacy Frames 'CheckoutCom' record and 'CKO Native' are never surfaced as
// deposit tiles. 'CheckoutCom' is kept hidden defensively in case the back end
// still serves the record before the legacy sub-processor is decommissioned.
export const HIDDEN_CHECKOUT_PROCESSORS = ['CheckoutCom', 'CKO Native']

export const checkIfApplePayAvailable = async (portalAccountDomain?: PortalAccountDomain): Promise<boolean> => {
  // Apple Pay requires a secure context (HTTPS)
  if (window.isSecureContext && window.ApplePaySession) {
    const merchantID = getMerchantID(portalAccountDomain)
    const canMakePaymentsWithActiveCard = await window.ApplePaySession.canMakePaymentsWithActiveCard(merchantID)
    return canMakePaymentsWithActiveCard
  }
  return false
}
